import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { getOnboardingStatus, skipOnboarding } from './api';
import { OnboardingStatus } from './types';

export const useOnboardingStatus = () => {
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();

  return useQuery<OnboardingStatus, Error>({
    queryKey: ['onboardingStatus'],
    enabled: isAuthenticated && !!user,
    queryFn: async () => {
      const accessToken = await getAccessTokenSilently();
      return getOnboardingStatus({ accessToken });
    },
    retry: 3,
    refetchOnWindowFocus: false
  });
};

export const useSkipOnboarding = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  return useMutation<void, Error, void>({
    mutationFn: async () => {
      const accessToken = await getAccessTokenSilently();
      return skipOnboarding({ accessToken });
    },
    onSuccess: () => {
      // Optimistically mark onboarding as completed so UI updates immediately
      queryClient.setQueryData(['onboardingStatus'], { next_step: null });
      queryClient.invalidateQueries({ queryKey: ['onboardingStatus'] });
    }
  });
};
